<template>
  <div id="cleanMob">
    <transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->
      <div v-if="english" class="inner" key="english">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Clean<span
                  class="lastname"
                  style="cursor: auto; border-bottom: none"
                  >Mob</span
                >
              </h1>
              <p>
                I did an apprenticeship at a startup, CleanMob. I mainly worked
                on 2 project that are a dashboard page for the backoffice, and a
                Electrical Vehicle traject simulator<br /><br />
                <span class="image fit">
                  <iframe
                    :width="isMobile ? 300 : larger ? 1400 : 720"
                    :height="isMobile ? 168 : larger ? 787 : 405"
                    src="https://www.youtube.com/embed/8UKnypk7O2s"
                    title="YouTube video player"
                    frameborder="0"
                    allowfullscreen
                  ></iframe><br /><br />
                </span>
                <span class="image fit">
                  <iframe
                    :width="isMobile ? 300 : larger ? 1400 : 720"
                    :height="isMobile ? 168 : larger ? 787 : 405"
                    src="https://www.youtube.com/embed/LRWEOAFVcrk"
                    title="YouTube video player"
                    frameborder="0"
                    allowfullscreen
                  ></iframe><br /><br />
                </span>
              </p>
            </div>
          </section>
        </div>
      </div>

      <!-- --------------------- FRENCH --------------------- -->
      <div v-if="!english" class="inner" key="french">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Clean<span
                  class="lastname"
                  style="cursor: auto; border-bottom: none"
                  >Mob</span
                >
              </h1>
              <p>
                J'ai fais une alternance à CleanMob, une startup française. J'ai
                principalement travaillé sur 2 projets, une page dashboard pour
                le backoffice, et un simulateur de trajet pour véhicule
                électriques<br /><br />
                <span class="image fit">
                  <iframe
                    :width="isMobile ? 300 : larger ? 1400 : 720"
                    :height="isMobile ? 168 : larger ? 787 : 405"
                    src="https://www.youtube.com/embed/8UKnypk7O2s"
                    title="YouTube video player"
                    frameborder="0"
                    allowfullscreen
                  ></iframe><br /><br />
                </span>
                <span class="image fit">
                  <iframe
                    :width="isMobile ? 300 : larger ? 1400 : 720"
                    :height="isMobile ? 168 : larger ? 787 : 405"
                    src="https://www.youtube.com/embed/LRWEOAFVcrk"
                    title="YouTube video player"
                    frameborder="0"
                    allowfullscreen
                  ></iframe><br /><br />
                </span>
              </p>
            </div>
          </section>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "CleanMob",
  props: {
    larger: Boolean,
    english: Boolean,
    isMobile: Boolean,
  },
};
</script>